<template lang="pug">
.info-banner()
    LocalLoader(:height="20" style="width: 80px; height: 20px; padding-bottom: 15px;" verySmall)
    span.text(style="padding-top: 5px;") {{ text }}
</template>
  
<script>
import moment from "moment";

export default {
    props: {
        text: String,
    },
    data() {
        return {
            isOpen: false,

        };
    },
    methods: {

    },
    mounted() {

    },
    beforeDestroy() {

    }

};
</script>

<style lang="scss" scoped>
.info-banner {
    display: flex;
    align-items: center;
    background-color: $text-color;
    color: white;
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 10px;
}
.info-banner:hover {
  cursor: pointer;
  /* Add any other visual feedback for hover state */
}
.icon {
    margin-right: 15px;
}

.text {
    font-weight: $normal-Font-Weight;
    font-size: $medium-Font-Size;
}
</style>